import { createContext, useState } from "react";

export const AppContext = createContext();

const now = new Date();
const currentMonthIndex = now.getMonth() + 1;

export function AppGlobalContext({ children }) {
    const [selectedMonthId, setSelectedMonthId] = useState(currentMonthIndex);
    const [selectedYear, setSelectedYear] = useState(now.getFullYear());
    const [ignoredTags, setIgnoredTags] = useState([]);
    const [ignoredCategories, setIgnoredCategories] = useState([]);
    const [simulatedTransactions, setSimulatedTransactions] = useState({});
    const [user, setUser] = useState(null);

    const updateTransactionSimulation = ({ id, transactionType, isCredit, originalAmount, changedAmount, time }) => {
        console.log(`[updateTransactionSimulation] - id: ${id}, transactionType: ${transactionType}, isCredit: ${isCredit}, originalAmount: ${originalAmount}, changedAmount: ${changedAmount}`);

        const parsedTime = new Date(time);
        const key = generatekey(parsedTime.getFullYear(), parsedTime.getMonth() + 1);

        originalAmount = Math.abs(originalAmount);
        const delta = originalAmount - changedAmount;
        console.log(`delta: ${delta}`);

        simulatedTransactions[key] = simulatedTransactions[key] || {};
        simulatedTransactions[key][id] = { id, delta, changedAmount, isCredit };

        setSimulatedTransactions({ ...simulatedTransactions });
    };

    const removeTransactionSimulation = ({ id, time }) => {
        console.log(`[removeTransactionSimulation] - id: ${id}`);
        const parsedTime = new Date(time);
        const key = generatekey(parsedTime.getFullYear(), parsedTime.getMonth() + 1);
        if (!simulatedTransactions?.[key]?.[id]) {
            return;
        }

        delete simulatedTransactions[key][id];
        setSimulatedTransactions({ ...simulatedTransactions });
    }

    const getTransactionSimulation = (year, month) => {
        return simulatedTransactions[generatekey(year, month)] || {};
    }

    const generatekey = (year, month) => {
        return `${year}-${month}`;
    }

    const data = {
        selectedMonthId,
        setSelectedMonthId,
        selectedYear,
        setSelectedYear,
        ignoredTags,
        setIgnoredTags,
        ignoredCategories,
        setIgnoredCategories,
        simulatedTransactions,
        updateTransactionSimulation,
        removeTransactionSimulation,
        getTransactionSimulation,
        user,
        setUser,
    };

    return <AppContext.Provider value={data}>{children}</AppContext.Provider>;
}
